<template>
    <common-content-spacer height="medium">
        <div class="step-container">
            <div
                v-for="(step, index) in steps"
                :key="index"
                :class="{ 'step--active': index === currentStepIndex, 'step--before': index < currentStepIndex, step: true }"
            >
                <div class="step--circle">
                    <span v-if="index >= currentStepIndex">{{ index + 1 }}</span>
                    <span v-if="index < currentStepIndex">
                        <common-icon name="white-check" size="huge"></common-icon>
                    </span>
                </div>
                <p v-if="!isMobileLarge" class="step--text">{{ step.displayName }}</p>
            </div>
        </div>
        <div class="step-content">
            <slot :name="steps[currentStepIndex].name"></slot>
        </div>
    </common-content-spacer>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            steps: { type: Array, required: true },
            currentStepIndex: { type: Number, required: true },
        },

        methods: {
            prevStep() {
                this.$emit('update:currentStepIndex', this.currentStepIndex - 1)
            },
            nextStep() {
                this.$emit('update:currentStepIndex', this.currentStepIndex + 1)
            },
        },
    }
</script>
